import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'class-names';
import { connect } from 'react-redux';
import { formatMoney } from '../../functions';
import {
  closeCart,
  addItem, populateItems, updateItem,
} from '../../redux/cart/actions';
import CartItem from './CartItem';
import CartGiftWrap from './CartGiftWrap';

class CartContent extends Component {
  constructor(props) {
    super(props);
    const { populateItems, pageLoadItems } = props;

    populateItems(pageLoadItems);
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props;
    if (!prevProps.isOpen && isOpen) {
      document.body.style.overflow = 'hidden';
    } else if (prevProps.isOpen && !isOpen) {
      document.body.style.overflow = '';
    }
  }

  packagingProductIds() {
    const {
      packagingProduct1,
      packagingProduct2,
    } = this.props.themeSettings;
    const packagingProductIds = []
    packagingProduct1 && packagingProductIds.push(String(packagingProduct1.id))
    packagingProduct2 && packagingProductIds.push(String(packagingProduct2.id))
    
    return packagingProductIds
  }

  isGiftWrapEnabled() {
    const {
      giftWrapEnabled,
      packagingProduct1,
      packagingProduct2,
    } = this.props.themeSettings;

    return giftWrapEnabled && (packagingProduct1 || packagingProduct2);
  }  

  render() {
    let subtotal = 0;
    const {
      items, isOpen, themeSettings, isGiftActive,
    } = this.props;

    items.forEach((item) => {
      subtotal += item.quantity * item.itemPriceCents;
    });

    const giftWrapCol = items?.length
      ? (
        <div className={`col-12 ${isGiftActive ? '' : 'col-lg-auto'}`}>
          <CartGiftWrap {...themeSettings} />
        </div>      
      )
      : ''

    const renderedItems = this.isGiftWrapEnabled()
      ? items.filter((cartItem) => {
        return !(this.packagingProductIds().includes(String(cartItem.productId)))
      })
      : items


    return (
      <div className={classNames('cart', { 'cart--open': isOpen })}>
        <div className="">
          <table className="cart__table">
            <thead className="cart__thead">
              <tr>
                <th className="cart__image" aria-label="image" />
                <th className="cart__info">Item</th>
                <th className="cart__quantity">Quantity</th>
                <th className="cart__price">Price</th>
              </tr>
            </thead>
            <tbody className="cart__tbody">
              {renderedItems && renderedItems.map((item) => (
                <CartItem item={item} key={item.key} />
              ))}
            </tbody>
          </table>

          <div className="row">
            {giftWrapCol}
            <div className="col-12 col-lg">
              <p className="text-right mb-3">
                Subtotal:&nbsp;
                <span>{Shopify.currency.active + " " + formatMoney(subtotal)}</span>
              </p>
              <p className="text-right">Taxes and Shipping calculated at checkout</p>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
  isOpen: state.cart.isOpen,
  items: state.cart.items,
  isGiftActive: state.cart.isGiftActive,
});

const mapDispatchToProps = {
  closeCart,
  addItem,
  populateItems,
  updateItem,
};

CartContent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isOpen: PropTypes.bool,
  populateItems: PropTypes.func.isRequired,
  pageLoadItems: PropTypes.arrayOf(PropTypes.object),
  themeSettings: PropTypes.objectOf(PropTypes.any),
  isGiftActive: PropTypes.bool.isRequired,
};

CartContent.defaultProps = {
  items: [],
  pageLoadItems: [],
  isOpen: false,
  themeSettings: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(CartContent);
